import { default as Error } from './Error';
import { default as Info } from './Info';
import * as Props from './interfaces';

const Notification = {
  Error,
  Info
};

export type { Props };
export default Notification;
